export const POs = (state) => state.POs
export const selectAllField = (state) => state.selectAllField
export const getTemplateId = (state) => state.purchaseOrderTemplateId
export const selectedPOs = (state) => state.selectedPOs
export const totalPOs = (state) => state.totalPOs
export const selectedSupplier = (state) => state.selectedSupplier
export const getPO = (state) => (id) => {
  let invId = parseInt(id)
  return state.POs.find(PO => PO.id === invId)
}
export const POForDeliveryNotes = (state) => state.POForDeliveryNotes
export const POForInvoices = (state) => state.POForInvoices